import React from 'react';

const BrandLogo = () => {
    return (
        <div
            style={{
                color: '#000',
                textAlign: 'center',
                fontFamily: 'Playfair Display, serif',
                fontSize: '24px',
                fontWeight: 900,
                display: 'flex',
                padding: '24px 0',
                marginLeft: '470px',
            }}
        >
            Be:Seen
        </div>
    );
};

export default BrandLogo;
